<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="onCancel">
        <span aria-hidden="true">x</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">Êtes-vous sûr de vouloir changer le commercial ?</h4>
    </div>
    <div class="modal-body">
      <div> Assigner le commercial {{ accountManager.fullname }} pour la commande {{ commandId }} ?</div> 
    </div>
    <div class="modal-footer justify-content-center">
      <button type="button"
              class="btn btn-danger"
              @click="onCancel">Annuler</button>
      <button type="button"
              class="btn btn-primary"
              @click="onConfirm">Assigner le commercial</button>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'
  import gql from 'graphql-tag'

  export default {
    data: () => ({
      store,
    }),

    computed: {
      model () {
        return store.modal
      },
      commandId () {
        return store.modal.dataModel.commandId
      },
      accountManager () {
        return store.modal.dataModel.accountManager
      },
      editCommercial() {
        return gql`
          mutation {
            modifyOrder(
              orderId:"${this.commandId}",
              commercial:"${this.accountManager.id}",
            ) {
              result
            }
          }
        `
      }
    },

    methods: {
     onConfirm () {
        this.$bus.$emit('validate-account-manager-modification-' + this.commandId, this.commandId);
        this.$apollo.mutate({
          mutation: this.editCommercial
        }).then(() => {
          this.closeModal()
          this.showBanner('success', `Succès: le commercial ${this.accountManager.fullname} est assigné a la commande #${this.commandId}.`)
        }, () => {
          this.closeModal()
          this.showBanner('danger', `Le commercial ${this.accountManager.fullname} n'a pas était assigné a la commande #${this.commandId}.`)
        })
      },
      onCancel () {
        this.$bus.$emit('cancel-account-manager-modification-' + this.commandId, this.commandId);
        this.closeModal();
      }
    }
}
</script>
